module.exports = __webpack_public_path__ + "img/image@2x.6e2d35bd.png";